import {
    $, _, addAction, INIT,
} from '@situation/setdesign.util';

addAction(INIT, () => {
    const watchComponents = {
        'content-background-image': 'content-background-image--on',
        heading__inner: 'heading__inner--on',
        'talent-card': 'talent-card--on',
    };
    let delay = 0;
    const resetDelay = _.debounce(() => {
        delay = 0;
    }, 500);
    $.each(watchComponents, (watch, modifier) => {
        SetDesign.scrollWatch($(`.${watch}`), (el) => {
            const $this = $(el);
            setTimeout(() => {
                $this.addClass(modifier);
            }, delay);

            delay += 50;
            resetDelay();
        });
    });
});
